import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var _TokenListProvider$st;

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { fetch } from 'cross-fetch';
import tokenlist from './../tokens/solana.tokenlist.json';
export var ENV;

(function (ENV) {
  ENV[ENV["MainnetBeta"] = 101] = "MainnetBeta";
  ENV[ENV["Testnet"] = 102] = "Testnet";
  ENV[ENV["Devnet"] = 103] = "Devnet";
})(ENV || (ENV = {}));

export var CLUSTER_SLUGS = {
  'mainnet-beta': ENV.MainnetBeta,
  testnet: ENV.Testnet,
  devnet: ENV.Devnet
};
export var GitHubTokenListResolutionStrategy = function GitHubTokenListResolutionStrategy() {
  var _this = this;

  _classCallCheck(this, GitHubTokenListResolutionStrategy);

  this.repositories = ['https://raw.githubusercontent.com/solana-labs/token-list/main/src/tokens/solana.tokenlist.json'];

  this.resolve = function () {
    return queryJsonFiles(_this.repositories);
  };
};
export var CDNTokenListResolutionStrategy = function CDNTokenListResolutionStrategy() {
  var _this2 = this;

  _classCallCheck(this, CDNTokenListResolutionStrategy);

  this.repositories = ['https://cdn.jsdelivr.net/gh/solana-labs/token-list@main/src/tokens/solana.tokenlist.json'];

  this.resolve = function () {
    return queryJsonFiles(_this2.repositories);
  };
};
export var SolanaTokenListResolutionStrategy = function SolanaTokenListResolutionStrategy() {
  var _this3 = this;

  _classCallCheck(this, SolanaTokenListResolutionStrategy);

  this.repositories = ['https://token-list.solana.com/solana.tokenlist.json'];

  this.resolve = function () {
    return queryJsonFiles(_this3.repositories);
  };
};

var queryJsonFiles = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
    var responses;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all(files.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(repo) {
                var response, json;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return fetch(repo);

                      case 3:
                        response = _context.sent;
                        _context.next = 6;
                        return response.json();

                      case 6:
                        json = _context.sent;
                        return _context.abrupt("return", json);

                      case 10:
                        _context.prev = 10;
                        _context.t0 = _context["catch"](0);
                        console.info("@solana/token-registry: falling back to static repository.");
                        return _context.abrupt("return", tokenlist);

                      case 14:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 10]]);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
            responses = _context2.sent;
            return _context2.abrupt("return", responses.map(function (tokenlist) {
              return tokenlist.tokens;
            }).reduce(function (acc, arr) {
              return acc.concat(arr);
            }, []));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function queryJsonFiles(_x) {
    return _ref.apply(this, arguments);
  };
}();

export var Strategy;

(function (Strategy) {
  Strategy["GitHub"] = "GitHub";
  Strategy["Static"] = "Static";
  Strategy["Solana"] = "Solana";
  Strategy["CDN"] = "CDN";
})(Strategy || (Strategy = {}));

export var StaticTokenListResolutionStrategy = function StaticTokenListResolutionStrategy() {
  _classCallCheck(this, StaticTokenListResolutionStrategy);

  this.resolve = function () {
    return tokenlist.tokens;
  };
};
export var TokenListProvider = function TokenListProvider() {
  _classCallCheck(this, TokenListProvider);

  this.resolve = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var strategy,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            strategy = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : Strategy.CDN;
            _context3.t0 = TokenListContainer;
            _context3.next = 4;
            return TokenListProvider.strategies[strategy].resolve();

          case 4:
            _context3.t1 = _context3.sent;
            return _context3.abrupt("return", new _context3.t0(_context3.t1));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
TokenListProvider.strategies = (_TokenListProvider$st = {}, _defineProperty(_TokenListProvider$st, Strategy.GitHub, new GitHubTokenListResolutionStrategy()), _defineProperty(_TokenListProvider$st, Strategy.Static, new StaticTokenListResolutionStrategy()), _defineProperty(_TokenListProvider$st, Strategy.Solana, new SolanaTokenListResolutionStrategy()), _defineProperty(_TokenListProvider$st, Strategy.CDN, new CDNTokenListResolutionStrategy()), _TokenListProvider$st);
export var TokenListContainer = function TokenListContainer(tokenList) {
  var _this4 = this;

  _classCallCheck(this, TokenListContainer);

  this.tokenList = tokenList;

  this.filterByTag = function (tag) {
    return new TokenListContainer(_this4.tokenList.filter(function (item) {
      return (item.tags || []).includes(tag);
    }));
  };

  this.filterByChainId = function (chainId) {
    return new TokenListContainer(_this4.tokenList.filter(function (item) {
      return item.chainId === chainId;
    }));
  };

  this.excludeByChainId = function (chainId) {
    return new TokenListContainer(_this4.tokenList.filter(function (item) {
      return item.chainId !== chainId;
    }));
  };

  this.excludeByTag = function (tag) {
    return new TokenListContainer(_this4.tokenList.filter(function (item) {
      return !(item.tags || []).includes(tag);
    }));
  };

  this.filterByClusterSlug = function (slug) {
    if (slug in CLUSTER_SLUGS) {
      return _this4.filterByChainId(CLUSTER_SLUGS[slug]);
    }

    throw new Error("Unknown slug: ".concat(slug, ", please use one of ").concat(Object.keys(CLUSTER_SLUGS)));
  };

  this.getList = function () {
    return _this4.tokenList;
  };
};